<script setup lang="ts">
import { computed } from "vue";

import LeInflectionSchemeTable from "@/components/articles/dictsys/inflection-schemes/LeInflectionSchemeTable.vue";
import { DictsysGermanArticleInflectionSchemeHelper } from "@/helpers";
import type { DictsysGermanArticleInflectionScheme, DictsysInflectionSchemeTable } from "@/types";

const props = defineProps<{
  inflectionScheme: DictsysGermanArticleInflectionScheme;
  language: string;
}>();

const table = computed<DictsysInflectionSchemeTable | null>(() =>
  DictsysGermanArticleInflectionSchemeHelper.getTable(props.inflectionScheme)
);
</script>

<template>
  <div>
    <LeInflectionSchemeTable v-if="table" :tables="[table]" :language="props.language" />
  </div>
</template>
